import { Component, OnInit, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";

@Component({
    selector: "app-error-dialog",
    templateUrl: "./error-dialog.component.html",
    styleUrls: ["./error-dialog.component.scss"],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
  errors: any;

  constructor(
    public dialogRef: VngDialogRef<ErrorDialogComponent>,
    @Inject(VNG_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.errors = this.data.data;
  }

  close(): void {
    this.dialogRef.close();
  }

}
